import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import {
  toggleNavigation,
  setCurrentFilter,
  fetchDownloads,
  fetchNews,
  fetchProjects,
  fetchHomepageData,
  fetchTaxonomy,
  detectMouseState,
  fetchAboutData,
} from '../../actions/index';
import '../../styles/css/routerAnimation.css';
import Loadable from 'react-loadable';
import LoadingScreen from '../../components/loadingscreen/LoadingScreen';
import Loading from '../../components/loading/Loading';

const AsyncInnerApp = Loadable({
  loader: () => import('../innerapp/InnerApp'),
  render(loaded, props) {
    let Component = loaded.default;
    return <Component {...props} />;
  },
  loading() {
    return <Loading />;
  },
});

class App extends Component {
  constructor() {
    super();

    this.state = {
      touchDevice: false,
      loadedData: false,
    };
  }

  componentDidMount() {
    const {
      fetchNews,
      fetchProjects,
      fetchHomepageData,
      fetchDownloads,
      fetchTaxonomy,
      fetchAboutData,
    } = this.props;
    fetchNews();
    fetchProjects();
    fetchHomepageData();
    fetchTaxonomy('projects_category', 'projects');
    fetchTaxonomy('downloads_categories', 'downloads');
    fetchTaxonomy('projects_status_category', 'projects_status');
    fetchTaxonomy('categories', 'news');
    fetchDownloads();
    fetchAboutData();
    this.detectTouch();
  }
  shouldComponentUpdate(nextProps, nextState) {
    return nextState.loadedData;
  }
  componentWillReceiveProps(nextProps) {
    nextProps.news.length !== 0 &&
      nextProps.projects.length !== 0 &&
      nextProps.taxonomy.projects.length !== 0 &&
      this.setState({ loadedData: true });
  }

  detectTouch() {
    try {
      document.createEvent('TouchEvent');
      this.setState({ touchDevice: true });
    } catch (e) {
      this.setState({ touchDevice: false });
    }
  }

  render() {
    const {
      toggleNavigation,
      navVisible,
      routes,
      news,
      projects,
      taxonomy,
      detectMouseState,
    } = this.props;
    const { loadedData } = this.state;

    return (
      <Fragment>
        <LoadingScreen loaded={loadedData} />
        {loadedData && (
          <Fragment>
            <AsyncInnerApp
              toggleNavigation={toggleNavigation}
              navVisible={navVisible}
              routes={routes}
              news={news}
              projects={projects}
              taxonomy={taxonomy}
              detectMouseState={detectMouseState}
            />
          </Fragment>
        )}
      </Fragment>
    );
  }
}

function mapStateToProps(state) {
  return {
    mainNavigation: state.mainNavigation,
    navVisible: state.navVisible,
    news: state.news,
    projects: state.projects,
    taxonomy: state.taxonomy,
  };
}

export default connect(
  mapStateToProps,
  {
    toggleNavigation,
    setCurrentFilter,
    fetchNews,
    fetchProjects,
    fetchHomepageData,
    fetchTaxonomy,
    detectMouseState,
    fetchDownloads,
    fetchAboutData,
  }
)(App);



// WEBPACK FOOTER //
// ./src/containers/app/App.js